export const STORAGE_RATINGS = 'RATINGS';
export const STORAGE_TRACK_RATINGS = 'TRACK_RATINGS';
export const STORAGE_ALBUM_RATINGS = 'ALBUM_RATINGS';
export const STORAGE_ARTIST_RATINGS = 'ARTIST_RATINGS';
